webpackJsonp([0],{

/***/ 144:
/***/ (function(module, exports) {

$(document).ready(function () {
    // Prevent Enter key from closing the dropdown
    $('.js-search-designer, .js-enterable.checkbox__input').keydown(function (event) {
        if (event.keyCode === 13) {
            // Enter key
            event.preventDefault(); // Prevent default action (form submission)
            event.stopPropagation(); // Stop the event from propagating
        }
    });

    // Initialize the selected designers from the URL
    var selectedDesigners = getSelectedDesignersFromUrl();
    selectedDesigners.forEach(function (designer) {
        $('.js-enterable.checkbox__input[value="' + designer + '"]').prop('checked', true);
    });

    updateSelectedDesignersUI(selectedDesigners);

    // Designer Filter Search and Selection
    $('.js-search-designer').keyup(function () {
        // Directly use the user's input for the search, including symbols.
        // We escape special regex characters to prevent unexpected behavior.
        var value = $(this).val().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

        var numOfVisibleResults = 0;

        $('.filters__designer-list li').each(function () {
            var span = $(this).find('span');
            var originalText = span.text();
            // RegExp object for case-insensitive matching
            var regex = new RegExp(value, 'gi');

            if (originalText.search(regex) > -1) {
                // Replace the matched text with a bold version for highlighting
                var boldedText = originalText.replace(regex, function (match) {
                    return '<strong>' + match + '</strong>';
                });
                span.html(boldedText);
                $(this).removeClass('u-hide');
                numOfVisibleResults++;
            } else {
                // If there's no match, simply show the original text without any modification
                span.html(originalText);
                $(this).addClass('u-hide');
            }
        });

        if (numOfVisibleResults > 0) {
            $('.js-filter-search-no-results').hide().empty();
        } else {
            $('.js-filter-search-no-results').html('No results found.').show();
        }
    });

    $('.js-enterable.checkbox__input').change(function () {
        var selectedDesigners = [];
        $('.js-enterable.checkbox__input:checked').each(function () {
            selectedDesigners.push($(this).val());
        });

        updateSelectedDesignersUI(selectedDesigners);
        updateUrlParameters(selectedDesigners);
    });

    $(document).on('click', '.js-remove-designer-selection', function () {
        var designerId = $(this).data('designer-id');
        $('.js-enterable.checkbox__input[value="' + designerId + '"]').prop('checked', false).trigger('change');
    });

    // Function to focus on the previous button
    function focusOnPreviousButton() {
        // Get the previous button element
        var previousButton = $('.selected-designers .js-filter-button:last');

        // Check if a previous button exists
        if (previousButton.length > 0) {
            // Set focus on the previous button
            previousButton[0].focus();
        }
    }

    // Function to handle keydown event
    function handleKeydown(event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
            var designerId = $(this).find('.js-remove-designer-selection').data('designer-id');
            $('.js-enterable.checkbox__input[value="' + designerId + '"]').prop('checked', false).trigger('change');

            focusOnPreviousButton();
            return false; // Prevent default action
        }
    }

    // Attach keydown event listener to dynamically inserted buttons
    $('.selected-designers').on('keydown', '.js-filter-button', handleKeydown);
});

function getUrlParameter(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    return results === null ? null : decodeURIComponent(results[1]) || null;
}

function getSelectedDesignersFromUrl() {
    var designers = [];
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach(function (value, key) {
        if (key === 'designer') {
            designers.push(value);
        }
    });
    return designers;
}

function updateUrlParameters(designers) {
    var url = new URL(window.location.href);
    url.searchParams.delete('designer');
    designers.forEach(function (designer) {
        url.searchParams.append('designer', designer);
    });
    window.history.pushState({}, '', url);
}

function updateSelectedDesignersUI(selectedDesigners) {
    var designerButtons = selectedDesigners.map(function (designer) {
        return '\n        <button\n            data-designer-id="' + designer + '"\n            class="btn btn--designer-filter btn--ghost-grey u-margin-r--lg u-margin-b--lg js-filter-button">\n            <span class="u-screen-reader">Remove </span>' + designer + '<span class="u-screen-reader"> from filter </span>\n            <span class="u-pointer icon icon--x icon--sm u-margin-l--sm js-remove-designer-selection" data-designer-id="' + designer + '">\n                <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">\n                    <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28\n                        4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8\n                        9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z">\n                    </path>\n                </svg>\n            </span>\n        </button>\n    ';
    }).join('');

    if (selectedDesigners.length > 0) {
        $('.selected-designers').html(designerButtons);
    } else {
        $('.selected-designers').html('');
    }
}

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

/* harmony default export */ __webpack_exports__["a"] = (function () {
    var productData = {}; // populated via ajax below.
    var codes = []; // List of product codes for which to retrieve data.
    var department = "F"; // Default to women's. Set later when we find out for sure.
    var layoutChangeHandlers = [];
    var defaults = {
        showMoreColorsText: _get(window, 'rcProps.translations.showMoreColorsText', "show more colors for"),
        showLessColorsText: _get(window, 'rcProps.translations.showLessColorsText', "show less colors for")
    };

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("resize", onLayoutChange);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("layout-change", onLayoutChange);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("content-load", onContentLoad);
    onContentLoad(); // On initial page load, don't wait for content-load event.

    function _get(object, path) {
        var defval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        if (typeof path === "string") path = path.split(".");
        return path.reduce(function (xs, x) {
            return xs && xs[x] ? xs[x] : defval;
        }, object);
    }

    function onContentLoad() {

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("li.products-grid__item").each(function () {
            var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            var $swatchContainer = $div.find('.js-plp-swatches');
            if ($swatchContainer.length) {
                // make sure to only bind events once
                if ($swatchContainer.data('colorSwatchesEvent') === true) {
                    return;
                }
                $swatchContainer.data('colorSwatchesEvent', true);
                createSwatchDropDown($swatchContainer);
            }
            createSwatchClickHandlers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
        });
        if (codes && codes.length > 0) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: "/r/ajax/GetSwatchData.jsp",
                dataType: "json",
                type: "POST",
                data: {
                    product: codes,
                    d: department
                },
                success: function success(json) {
                    productData = json;
                }
            });
        }
    }

    window.bindColorSwatchEvent = onContentLoad;

    // columnView.js fires a custom event when it changes the layout.
    function onLayoutChange(event) {
        // This doesn't need to be synchronous. Let the event handler return
        // to re-flowing the page.
        window.setTimeout(function () {
            layoutChangeHandlers.forEach(function (f) {
                try {
                    f(event);
                } catch (e) {
                    console.log(e);
                }
            });
        }, 1);
    }

    function createSwatchClickHandlers($div) {
        var $heart = $div.find('.js-favorite-button');
        var $qv = $div.find(".js-plp-quickview");
        var $img = $div.find(".js-plp-image"); // *Seems to be the only one... need to add class.
        var $altImg = $div.find(".js-plp-altview");
        var $name = $div.find(".js-plp-name");
        var $brand = $div.find(".js-plp-brand");
        var $price = $div.find(".js-plp-price");
        var $link = $div.find(".js-plp-pdp-link");
        var $link2 = $div.find(".js-plp-pdp-link2");
        var $retail = $div.find(".js-plp-price-retail");
        var $swatches = $div.find(".product-swatches__swatch");
        var $badgeContainer = $div.find('.js-badge-container');
        var $similaritemslink = $div.find(".js-plp-similar-items-link");
        $swatches.each(function () {
            var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code");
            department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("department") || department; // Just stomp on the value. Last one wins.
            codes.push(code);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).click(function () {
                var $colorWay = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                $swatches.prop('checked', false); // desktop
                $swatches.removeClass("plp_active_color "); // mobile
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('checked', true); // desktop
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("plp_active_color"); // mobile
                if (code in productData) {
                    var prod = productData[code];
                    $img.attr("src", prod.imgPlp);
                    $img.attr("data-src", prod.imgPlp);
                    if (prod.imgPlpRetina) {
                        $img.attr("srcset", prod.imgPlpRetina + " 2x, " + prod.imgPlp + " 1x");
                    } else {
                        $img.attr("srcset", prod.imgPlp + " 2x, " + prod.imgPlp + " 1x");
                    }

                    if (prod.imgHoverView) {
                        $altImg.attr("src", prod.imgHoverView);
                        $altImg.data('lazySrc', prod.imgHoverView);
                        if (prod.imgHoverViewRetina) {
                            $altImg.attr("srcset", prod.imgHoverViewRetina + " 2x, " + prod.imgHoverView + " 1x");
                            $altImg.data('lazySrcset', prod.imgHoverViewRetina + " 2x, " + prod.imgHoverView + " 1x");
                        } else {
                            $altImg.attr("srcset", prod.imgHoverView + " 2x, " + prod.imgHoverView + " 1x");
                            $altImg.data('lazySrcset', prod.imgHoverView + " 2x, " + prod.imgHoverView + " 1x");
                        }
                    }
                    $name.html(prod.name);
                    $brand.html(prod.brand);
                    if (prod.priceMarkup) {
                        $div.find('.js-plp-prices-div').html(prod.priceMarkup);
                    } else {
                        $price.html(prod.price);
                        $retail.html(prod.retailPrice);
                    }

                    $badgeContainer.empty();
                    var badgeText = $colorWay.data('badge');
                    if (badgeText) {
                        var badgeHref = $colorWay.data('badgeHref');
                        var badgeTemplate = badgeHref ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#linked-badge-template') : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#unlinked-badge-template');
                        $badgeContainer.append(Mustache.render(badgeTemplate.text(), {
                            badgeText: badgeText,
                            badgeClass: $colorWay.data('badgeClass'),
                            link: badgeHref
                        }));
                    }
                    $link.prop("href", prod.url);
                    $link2.prop("href", prod.url);
                    $qv.data("code", code); // Updates parameter value to Quick View code.
                    $heart.data("code", code);

                    $similaritemslink.data("code", code);

                    toggleHeart($heart, prod.isFavorite);

                    var productImageContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.products-grid__item').find('.product-grids__image')[0];
                    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').data('plp-model-image-first')) {
                        swapMainAndHoverImagesForProduct(productImageContainer);
                    }
                }
            });
        });
        $heart.click(function () {
            var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code");
            toggleHeart($heart, isFavorite($heart));
            if (productData[code]) {
                productData[code].isFavorite = !productData[code].isFavorite;
            }
        });
    }

    function isFavorite($heart) {
        return $heart.hasClass('favorite-button--active') || $heart.find('span.fav_heart').hasClass('hearted_active');
    }

    function toggleHeart($heart, isFavorite) {
        switch ($heart.prop("tagName")) {// On main, we use "button". On mobile, we use "a". Adjust needed class accordingly.
            case "BUTTON":
                $heart.toggleClass("favorite-button--active", isFavorite);
                break;
            default:
                $heart.find("span.fav_heart").toggleClass("hearted_active", isFavorite);
                break;
        }
    }

    function createSwatchDropDown($container) {
        var visible;
        var $toggle;
        var $down;
        var $up;

        function toggleSwatches() {
            visible ? hide() : show();
        };

        function hide() {
            $container.removeClass('product-swatches--plp--active');
            $up.hide();
            $down.show();
            visible = false;
            $container.find('.js-swatch-toggle-text').text(defaults.showMoreColorsText);
        }

        function show() {
            $container.addClass('product-swatches--plp--active');
            $down.hide();
            $up.show();
            visible = true;
            $container.find('.js-swatch-toggle-text').text(defaults.showLessColorsText);
            var $firstSwatch = $container.find('.js-plp-swatch > .product-swatches__radio:eq(7)');
            if ($firstSwatch.length) {
                $firstSwatch.focus();
            } else {
                // If there are less than eight swatches, focus the first one
                $container.find('.js-plp-swatch:first').focus();
            }
        }

        function handleInteraction(event) {
            if (event.type === 'click' || event.type === 'keydown' && event.keyCode === 13) {
                event.preventDefault();
                toggleSwatches();
            } else {
                return;
            }
        }

        function init(event) {
            var containerWidth = $container.width();
            var numWide = Math.floor(containerWidth / swatchWidth);

            if (numWide >= numSwatches) {
                $toggle.hide();
            } else {
                $toggle.show();
                $up.hide();
                $down.show();
                visible = false;

                $toggle.on('click.swatch', function (event) {
                    var $swatchContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().prev();
                    $swatchContainer.find('.js-plp-lazy-swatch-img').each(function () {
                        var $swatch = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                        $swatch.attr("src", $swatch.data('src'));
                    });

                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).off("click.swatch");
                });

                $toggle.on('keydown', function (event) {
                    if (event.keyCode !== 13 && event.keyCode !== 32) {
                        return;
                    }
                    var $swatchContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().prev();
                    $swatchContainer.find('.js-plp-lazy-swatch-img').each(function () {
                        var $swatch = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                        $swatch.attr("src", $swatch.data('src'));
                    });
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).off("keydown");
                });
            }
        }

        if ($container.find(".js-plp-swatch").length > 1) {
            visible = false;
            var $swatches = $container.find(".js-plp-swatch");
            $toggle = $container.find(".js-swatch-toggle-container");
            $down = $toggle.find(".js-swatch-toggle-down");
            $up = $toggle.find(".js-swatch-toggle-up");

            var numSwatches = $swatches.length + 1;

            $down.add($up).css('pointer-events', 'none');

            $toggle.on('click', function (event) {
                event.preventDefault();
                handleInteraction(event);
            });

            $toggle.on('keydown', function (event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    event.preventDefault();
                    handleInteraction(event);
                }
            });

            // Keep some dimensions handy.
            // We can't reliably determine the height of a single row of swatches, since we'd need to take into account
            // padding, margins, etc. $.position() is likewise unreliable since it returns a position relative to the
            // nearest offsetParent, which depends on CSS properties and might not be the actual parent. So we take a
            // good guess: we know how many rows there are, and we figure they're probably devided more-or-less evenly.

            var swatchWidth = $swatches.outerWidth() + Math.max(parseInt($swatches.css("margin-right")), parseInt($swatches.css("margin-left")));
            layoutChangeHandlers.push(init);
            init();

            $down.click(toggleSwatches);
            $up.click(toggleSwatches);
            hide();
        }
    }
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SS_MENU_CLASS */
/* unused harmony export SS_TRIGGER_CLASS */
/* unused harmony export SS_ATB_CLASS */
/* unused harmony export SS_PARENT_CONTAINER_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pdp_add_to_bag__ = __webpack_require__(39);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */







var PLUGIN_NAME = 'sizeSelection';
var SS_MENU_CLASS = '.js-select-size-menu';
var SS_TRIGGER_CLASS = '.js-select-size-trigger';
var SS_ATB_CLASS = '.js-btn-atb';
var SS_PARENT_CONTAINER_CLASS = '.js-plp-product';

var DEFAULTS = {
    animationSpeed: 100
};

/**
 * Prevent Hash
 * @param  {event} interaction event
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 */
var preventHash = function preventHash(evt, $saveSizeTrigger) {
    if (__WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ENTER' || evt.type == 'click') {
        if ($saveSizeTrigger.attr('href') == "#") {
            evt.preventDefault();
        }
    }
};

var setLoading = function setLoading($el) {
    $el.closest('.js-product-info-block').append(progressBarHTML());
};
var removeLoading = function removeLoading($el) {
    $el.closest('.js-product-info-block').find('.plp__size-loading').remove();
};

var progressBarHTML = function progressBarHTML() {
    return '<div class="plp__size-loading">\n        <div class="u-padding-a--xl">\n                <div class="progress-bar progress-bar--dark">\n                    <div class="u-screen-reader">\n                        Content is Loading\n                    </div>\n                </div>\n            </div>\n        </div>';
};

var openSizes = function openSizes($el, $saveSizeTrigger, $saveSizeMenu, opts) {
    $el.addClass('ss-is-open');
    $saveSizeMenu.css({ display: 'block', opacity: 0, visibility: 'visible' }).stop().animate({
        opacity: 1
    }, opts.animateSpeed, function () {});
    setClickCloseListener($el, $saveSizeTrigger, $saveSizeMenu, opts);
};

var closeSizes = function closeSizes($el, $saveSizeMenu, opts) {
    $el.removeClass('ss-is-open');
    $el.find('.js-select-size-menu').remove();
    $el.find('input[type=radio][name=fav-size-selection]').off('change.size');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.close');
    $saveSizeMenu.stop().animate({
        opacity: 0
    }, opts.animateSpeed / 2, function () {
        $saveSizeMenu.css('display', 'none', 'visibility', 'hidden');
    });
};

var showConfirmation = function showConfirmation($saveSizeTrigger, opts, hasError) {
    var saveSizeConfirmPath = opts.saveSizeConfirmPath;

    if (saveSizeConfirmPath) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            url: '' + saveSizeConfirmPath,
            type: 'notification',
            triggerOpen: true,
            returnFocus: $saveSizeTrigger
        });
    }
};

var updateSizeCopy = function updateSizeCopy($saveSizeTrigger, sizeValue, $parentContainer, opts, preorder) {
    var code = opts.code;

    if (!opts.noCopyUpdate) {
        $saveSizeTrigger.html('<span id="' + code + '-fav-size-value" data-size="' + sizeValue + '">Size: ' + sizeValue + '</span>');
    }

    if ($parentContainer) {
        var $addToBag = $parentContainer.find(SS_ATB_CLASS);
        $addToBag.data("size", sizeValue);
        $addToBag.data("oos", false);
        if (preorder) {
            $addToBag.html("PreOrder");
        } else {
            $addToBag.html("add to bag");
        }
    }
};

/**
 * Focus trap utility for size menu popover
 */
var trapModalFocus = function trapModalFocus($menu) {
    var radios = $menu.find('input[type=radio]:not([disabled])').filter(':visible');
    var first = radios[0];
    var last = radios[radios.length - 1];

    $menu.find('.js-focus-start').on('focus', function () {
        if (last) last.focus();
    });

    $menu.find('.js-focus-end').on('focus', function () {
        if (first) first.focus();
    });
};

var keydownHandler = function keydownHandler($el, evt, $saveSizeTrigger, $parentContainer, opts, isKey) {
    var key = __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt);
    var isEnter = key === 'ENTER';
    var isNextArrows = key === 'ARROWRIGHT' || key === 'ARROWDOWN';
    var isPrevArrows = key === 'ARROWLEFT' || key === 'ARROWUP';
    var isEscape = key === 'ESCAPE';
    var sizeHaveFocus = $el.find('input[type=radio]').is(":focus");

    var $saveSizeMenu = $el.find('.js-select-size-menu');

    // ENTER: open or select size
    if (isEnter) {
        if (!$el.hasClass('ss-is-open')) {
            evt.preventDefault();
            getSizes($el, $saveSizeTrigger, $parentContainer, opts, isKey);
            return;
        }

        if (sizeHaveFocus) {
            var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target);
            var sizeIsChecked = $target.is(':checked');
            var sizeValue = $target.prop('value');
            var preorder = $target.data('preorder');

            if (!sizeIsChecked) {
                updateSizeCopy($saveSizeTrigger, sizeValue, $parentContainer, opts, preorder);
            }

            updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue);
        }
    }

    // Arrow key navigation
    if ((isNextArrows || isPrevArrows) && sizeHaveFocus) {
        setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, $parentContainer, isKey, opts);
    }

    // ESCAPE: close the modal
    if (isEscape) {
        closeSizes($el, $saveSizeMenu, opts);
        return;
    }
};

var setUpdateSizeListener = function setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, $parentContainer, isKey, opts) {

    $el.find('input[type=radio]').on('change.size', function (evt) {
        var sizeValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('value');
        var preorder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("preorder");
        updateSizeCopy($saveSizeTrigger, sizeValue, $parentContainer, opts, preorder);
        var atb = opts.addToBag;

        if (!isKey) {
            updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue, atb);
        }
        if (atb === 'true' || atb === true) {
            var $addToBag = $parentContainer.find(SS_ATB_CLASS);
            if ($addToBag.length) {
                $addToBag.click();
            } else {
                addItemToBag(opts.code, sizeValue);
            }
        }
    });
};

var updateSizeToDb = function updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue, atb) {
    if (sizeValue) {
        var updateSizePath = opts.updateSizePath,
            code = opts.code;

        setLoading($el);
        removeLoading($el);
        closeSizes($el, $saveSizeMenu, opts);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size-menu').remove();
        if (updateSizePath) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                url: '' + updateSizePath + sizeValue,
                type: "POST",
                success: function success(_success) {
                    removeLoading($el);
                    if (_success) {
                        closeSizes($el, $saveSizeMenu, opts);
                        if (atb !== 'true') {
                            showConfirmation($saveSizeTrigger, opts, false);
                        }
                        if (typeof logEngagementWithDetails === "function") {
                            logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', 'size=' + sizeValue + ', code=' + code);
                        }
                    }
                }
            });
        }
    } else {
        closeSizes($el, $saveSizeMenu, opts);
        showConfirmation($saveSizeTrigger, opts, true);
    }
};

var setClickCloseListener = function setClickCloseListener($el, $saveSizeTrigger, $saveSizeMenu, opts) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.close', function (evt) {
        var $sizeMenu = $el.find('.js-select-size-menu');
        var notSizeMenu = !$sizeMenu.is(evt.target);
        var notSizeOption = $sizeMenu.has(evt.target).length === 0;
        var notTriggerBtn = evt.target !== $saveSizeTrigger[0];
        if (notSizeMenu && notSizeOption && notTriggerBtn) {
            closeSizes($el, $saveSizeMenu, opts);
        }
    });
};

var getSizes = function getSizes($el, $saveSizeTrigger, $parentContainer, opts, isKey) {
    var sizePath = opts.sizePath;

    opts.addToBag = $saveSizeTrigger.data('addToBag');
    $saveSizeTrigger.data('addToBag', 'false');
    setLoading($el);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: '' + sizePath,
        type: "GET",
        success: function success(sizePopupMarkup) {
            removeLoading($el);
            $saveSizeTrigger.after(sizePopupMarkup);
            var $saveSizeMenu = $el.find(SS_MENU_CLASS);
            openSizes($el, $saveSizeTrigger, $saveSizeMenu, opts);
            trapModalFocus($saveSizeMenu);
            if (!isKey) {
                setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, $parentContainer, isKey, opts);
            }
        }
    });
};

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $saveSizeTrigger, $parentContainer, opts) {

    $el.on('keydown', function (evt) {
        keydownHandler($el, evt, $saveSizeTrigger, $parentContainer, opts, true);
    });
    $saveSizeTrigger.on('click', function (evt) {
        evt.preventDefault();
        if (opts.oneSize && opts.addToBag) {
            addItemToBag(opts.code, 'all');
        } else {
            getSizes($el, $saveSizeTrigger, $parentContainer, opts, false);
        }
    });
    // $saveSizeTrigger.on('keydown', (evt) => {
    //     preventHash(evt, $saveSizeTrigger);
    // });
};

var addItemToBag = function addItemToBag(code, size) {
    if (window.rcProps.plp) {
        window.rcProps.pdp = window.rcProps.pdp || {};
        window.rcProps.pdp.sectionURL = window.rcProps.plp.sectionurl;
        window.rcProps.pdp.sessionID = window.rcProps.plp.sessionId;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pdp_add_to_bag__["a" /* default */])(code, size);
};

/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
function sizeSelection(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
    var $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
    var $parentContainer = $el.closest(SS_PARENT_CONTAINER_CLASS);
    setEventListeners($el, $saveSizeTrigger, $parentContainer, opts);
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeSelection);

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module plpLazyLoad
 */







var PLUGIN_NAME = 'plpLazyLoad';
var DEFAULTS = {
  loadAfterCallback: function loadAfterCallback() {}
};

var CLICK = 'click';
var ANCHOR = 'a';
var HTML = 'html';
var LOAD = 'load';
var PLPSESSIONKEY = "plpSession";
var MAXSESSION = 21;

/**
* This will check if current session exists
* If not, create an array
* If exists, get the object from the session
*/
var getPositionFromTopOnClick = function getPositionFromTopOnClick() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(HTML).on(CLICK, ANCHOR, function () {
    var plpSessionArray = sessionStorage.getItem(PLPSESSIONKEY);
    plpSessionArray = JSON.parse(plpSessionArray) || [];
    // Gets a new JSON data with current url and position
    var plpSessionUrlPosition = {
      currentUrl: window.location.href,
      currentPosition: window.scrollY
    };
    if (plpSessionArray.length > MAXSESSION) {
      plpSessionArray.shift();
    } else {
      plpSessionArray.push(plpSessionUrlPosition);
    }
    // Push the object to the array
    sessionStorage.setItem(PLPSESSIONKEY, JSON.stringify(plpSessionArray));
  });
};

/**
* Initializes lazy loading for plp
* @param  {jQuery} $el - The ul container element
* @param  {Object} [options={}] - Any options provided upon initialization
* @return {Object} Immutable version of the options*
*/
var lazyLoadPlp = function lazyLoadPlp($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  getPositionFromTopOnClick();
  var lazyAnimation = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(progressBarHTML());

  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: options.lazyLoadUrl,
    cache: false,
    success: function success(result) {
      $el.parent().css('min-height', '');
      $el.append(result);
      options.loadAfterCallback();
      $window.off("scroll.plp-lazy-load");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination-alternative').show();
      lazyAnimation.hide();
      /*
      * checks if user interact with the browser back button
      * this if statement will get the session and most recent position from the object
      */
      var windowPerformance = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'performance');
      if (windowPerformance && windowPerformance.navigation.type == windowPerformance.navigation.TYPE_BACK_FORWARD) {
        /* gets the object array from plpSession */
        var sessionObj = JSON.parse(sessionStorage.getItem(PLPSESSIONKEY));
        /* removes the last object from the array but also gets the values */
        var lastObj = sessionObj.pop();
        /*  scrolls to the position */
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop(lastObj.currentPosition);
        /* set the new session again */
        sessionStorage.setItem(PLPSESSIONKEY, JSON.stringify(sessionObj));
      }
    }
  });

  $window.on("scroll.plp-lazy-load", __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function () {
    var windowHeight = $window.height();
    var scrollPosY = $window.scrollTop() + windowHeight;
    var targetTop = $el.offset().top;
    if (scrollPosY >= targetTop) {
      $el.after(lazyAnimation);
      $window.off("scroll.plp-lazy-load");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination-alternative').hide();
    }
  }, 10));
};
var progressBarHTML = function progressBarHTML() {
  return '<div id="js-trigger-load-plp" class="u-padding-b--xl">\n       <div class="progress-bar__lazy u-margin--center">\n         <div class="u-padding-a--xl">\n           <div class="progress-bar">\n             <div class="u-screen-reader">\n               Products are loading\n             </div>\n           </div>\n         </div>\n       </div>\n     </div>';
};

/**
* Initializes plpLazyLoad.
* @param {jQuery} el - targeting the element of the plp list
* @param {Object} options - Options used for wiring up the plpLazyLoad
* @see DEFAULTS
*/
function plpLazyLoad(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  lazyLoadPlp($el, opts);
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, plpLazyLoad);

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_plp_lazy_load__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__size_selection__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plpswatches__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_social_proof__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter_search__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__filter_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styleguide_modules_product_filter_search__ = __webpack_require__(75);









var FILTER_NAMES = ['designer', 'size', 'color', 'condition', 'heel'];
var FILTERS_APPLIED_DELIMITER = "-";
var token = null;

function delayedApplication(filter) {
    clearTimeout(token);
    token = setTimeout(function () {
        applyFilters({ filter: filter });
    }, 500);
}

function bindWishList() {
    __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].checkWihlistTagId();
    __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].bindWishListEvent();
}
window.updateItemCount = updateItemCount;
window.rebindWishList = bindWishList;

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    // We want to auto-hide the options when user clicks 'done' button.
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.dropdown--full').hover(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.dropdown__menu').show();
    }, function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.dropdown__menu').hide();
    }).find('.filters__apply-btn').click(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.dropdown__menu').hide();
    });

    FILTER_NAMES.map(function (filter) {
        getFilterInputs(filter).on('change', delayedApplication.bind(null, filter));
    });
    bindFilterAndSortBy();
    bindPaginationEvents();
    initPreNext();
    bindWishList();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__plpswatches__["a" /* default */])();
    window.onpopstate = function (event) {
        var queryStr = location.search.startsWith("?") ? location.search.substr(1) : location.search;
        queryStr = decodeURIComponent(queryStr).replace(/\+/g, ' ');
        var queryStrArray = queryStr.split("&");
        var params = {};
        for (var i in queryStrArray) {
            if (queryStrArray[i].indexOf('=') > -1) {
                var key = queryStrArray[i].substr(0, queryStrArray[i].indexOf('='));
                var value = queryStrArray[i].substr(queryStrArray[i].indexOf('=') + 1);
                params[key] = value;
            }
        }
        FILTER_NAMES.map(function (filter) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[type="checkbox"][name="' + filter + '"]').each(function () {
                var filterInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                var isChecked = queryStrArray.indexOf(filter + "=" + filterInput.val()) > -1;
                filterInput.prop('checked', isChecked);
            });
        });

        applyFilters(params, true);
    };

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-search').productFilterSearch();

    if (/filters=/.test(location.search)) {
        // has filter applied on page load
        FILTER_NAMES.forEach(function (filterName) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="' + filterName + '"]').each(function () {
                var filterInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                applyEnabledOrDisabledStyle(filterInput, filterInput.prop('disabled'), filterName);
            });
        });
    }
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-lazy-load').plpLazyLoad({
        loadAfterCallback: function loadAfterCallback() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-lazy-img').lazy({ bind: "event" });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__plpswatches__["a" /* default */])();
            __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].bindWishListEvent();

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modules_social_proof__["c" /* renderPlpSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-container').toArray().map(function (el) {
                return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).prop('id');
            }));
        }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
    updateLeftNavURLsOnLoad();
});

/* PLP Designer Filter - UX-18471 */
function clearPredictiveDesignerSearch() {
    // Clear the search input field
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-search-designer').val('');

    // Reset the designer list to show all designers
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.filters__designer-list li').each(function () {
        var span = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('span');
        var originalText = span.text();

        // Show the original text without bolding
        span.html(originalText);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-hide');
    });

    // Hide the "no results" message
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-search-no-results').hide().empty();

    // Uncheck all checkboxes and clear selected designers
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-enterable.checkbox__input').prop('checked', false);

    // Clear the selected designers list
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.selected-designers').html('');
}

function bindFilterAndSortBy() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-clear-filter').click(function (e) {
        var filter = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('type');
        e.preventDefault();
        getFilterInputs(filter).prop('checked', false);

        var filtersApplied = getFiltersApplied(window.location.search.substring(1));
        if (filter && filtersApplied.indexOf(filter) >= 0) {
            filtersApplied = removeFilterApplied(filtersApplied, filter);
            var url = window.location.href;
            url = filtersApplied.length ? replaceURLParameters(url, 'filters=' + filtersApplied) : removeURLParameter(url, 'filters');
            removeHash(url);
        }
        applyFilters();

        /* PLP Designer Filter - UX-18471 */
        if (filter === 'designer') {
            clearPredictiveDesignerSearch();
        }
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-clear-button').click(function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-empty-message').hide();
        e.preventDefault();
        clearFilters();
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sort-by').change(function (e) {
        applyFilters({ sortBy: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val() });
    });

    FILTER_NAMES.map(function (filter) {
        getFilterInputs(filter).on('change', delayedApplication.bind(null, filter));
    });
}

function bindPaginationEvents() {
    var pageSizeChangeCallback = function pageSizeChangeCallback(e) {
        var value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).is('a')) {
            value = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('sortBy');
        }
        setCookie("pageSize", value, 14);
        applyFilters();
    };

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('a.js-set-page-size').click(pageSizeChangeCallback);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('select.js-set-page-size').change(pageSizeChangeCallback);

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('a.js-sort-by').click(function (e) {
        // wish list sort by
        e.preventDefault();
        applyFilters({ sortBy: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('sortBy') });
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pagination').click(function (e) {
        e.preventDefault();
        applyFilters({ pageNum: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('pageNum') });
    });
}
// Optional page parameter sets the pageNum.
function applyFilters(filterParams, doNotUpdateHistory) {
    var showClearButton = false;
    filterParams = filterParams || {};
    FILTER_NAMES.map(function (filter) {
        var values = getFilterValues(filter);
        if (values.length) {
            showClearButton = true;
        }
        filterParams[filter] = values;
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-clear-button').toggle(showClearButton);
    if (!doNotUpdateHistory) {
        updateMainWindowUrl(filterParams);
    }
    appendFilterParamsToLeftNav(filterParams);
    updateContent(filterParams);
}

function keepFilters() {
    return window.rcProps && window.rcProps.keepRefineFilter;
}

function appendFilterParamsToLeftNav(filterParams) {
    if (!keepFilters()) {
        return;
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.plp__sidebar li.nav-list__item a').each(function () {
        var baseUrl = clearQueryParameters(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href"), filterParams);
        var newUrl = getUrlForParams(baseUrl, filterParams);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href", newUrl);
    });
}

function updateLeftNavURLsOnLoad() {
    if (!keepFilters()) {
        return;
    }
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-clear-button').is(':visible')) {
        var filterParams = {};
        FILTER_NAMES.forEach(function (filter) {
            filterParams[filter] = getFilterValues(filter);
        });
        // Might be better to just use the URL parameters but for now just getting the filter sequence
        filterParams.filter = getFiltersApplied(window.location.search.substring(1));
        appendFilterParamsToLeftNav(filterParams);
    }
}

function getQueryFromParams(params) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(params, true);
}

function updateMainWindowUrl(params) {
    removeHash(getUrlForParams(location.pathname + clearQueryParameters(location.search, params), params));
}

function getUrlForParams(base, params) {
    if (params.sortBy) {
        base = clearQueryParameters(base, { featuredCodes: true });
    }
    var url = appendQuery(base, getQueryFromParams(params));
    url = clearQueryParameters(url, { filter: '' });
    if (params.filter) {
        var filtersApplied = getFiltersApplied(url);
        var filtersNotApplied = {};
        for (var filterType in params) {
            if (filterType !== "filter") {
                if (params[filterType].length > 0) {
                    filtersApplied = addFilterApplied(filtersApplied, filterType);
                } else {
                    filtersNotApplied[filterType] = true;
                }
            }
        }
        for (var _filterType in filtersNotApplied) {
            filtersApplied = removeFilterApplied(filtersApplied, _filterType);
        }
        url = filtersApplied ? replaceURLParameters(url, 'filters=' + filtersApplied) : clearQueryParameters(url, { filters: '' });
    }
    return url;
}

// Inspired by https://stackoverflow.com/a/3855394
function getFiltersApplied(fullQueryString) {
    if (fullQueryString) {
        var qs = fullQueryString.split('&');
        if (qs) {
            for (var i = 0; i < qs.length; ++i) {
                var p = qs[i].split('=', 2);
                if (p[0] === 'filters') {
                    if (p.length == 1) return '';else return decodeURIComponent(p[1].replace(/\+/g, " ")).replace(/^=/, "");
                }
            }
        }
    }
    return '';
}

// https://stackoverflow.com/a/5298684
function removeHash(url) {
    var scrollV,
        scrollH,
        loc = window.location;
    if ("pushState" in history) {
        var urlWithoutHash = url ? url.replace('#', '') : loc.pathname + loc.search; // Last ditch effort to remove hash
        history.pushState("", document.title, urlWithoutHash);
    } else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}

function bindViewMoreButtonEvents() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal').toggleReveal();
}

/* jQuery's jqXHR doesn't *quite* cancel properly. So we encapsulate it here
 * and make sure old requests get properly disposed of.
 */
function ContentUpdate($container, url) {
    var canceled = false;

    this.go = function () {
        $container.css('opacity', '0.5');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax(url, {
            success: success
        });
        return this;
    };

    this.cancel = function () {
        canceled = true;
    };

    function success(data) {
        if (!canceled) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-product-list').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-product-list', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data)).html());
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-product-list div').first().css('min-height', '');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-header .js-dropdown').dropdown();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#plp-header .js-filter-clear-button').click(function (e) {
                e.preventDefault();
                FILTER_NAMES.map(function (filter) {
                    getFilterInputs(filter).prop('checked', false);
                });
                applyFilters();
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cur-sortby').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cur-sortby', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data)).html());
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cur-pageview').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cur-pageview', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data)).html());
            __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].updateItemCount(data);
            // $container.html(data);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({ scrollTop: 0 }, 0);
            $container.animate({ opacity: 1 }, 200);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('content-load');
            dynamicallyDisableFilters();
            bindPaginationEvents();
            initPreNext();
            __WEBPACK_IMPORTED_MODULE_1_modules_wishlist__["a" /* default */].bindWishListEvent();
            bindViewMoreButtonEvents();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
            if (typeof window.insertPageTrackForMultiItemQuickView === "function") {
                window.insertPageTrackForMultiItemQuickView(url);
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__modules_social_proof__["c" /* renderPlpSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-container').toArray().map(function (el) {
                return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).prop('id');
            }));
        } else {
            console.log("cancelled: " + url);
        }
    }
}

var updateContent = function () {
    var pending = null;
    return function (params) {
        if (pending) {
            pending.cancel();
            pending = null;
        }
        var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#productsList');
        var url = $container.data('base-url');
        url = clearQueryParameters(url, params);
        url = replaceURLParameters(url, getQuery(window.location.href));
        pending = new ContentUpdate($container, url).go();
        return pending;
    };
}();

function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + (exdays == null ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + "; path=/";
}

function updateItemCount(numItems) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-item-count').html(numItems.toLocaleString());
    removeMsgNoProducts(numItems);
}

function removeMsgNoProducts(numItems) {
    if (numItems === 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-empty-message').show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#resetFilterMsgBtn').show();
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-filter-empty-message').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#resetFilterMsgBtn').hide();
    }
}

function addFilterApplied(filtersAppliedDelimited, filterToAdd) {
    var result = void 0;

    if (filtersAppliedDelimited) {
        result = filtersAppliedDelimited.indexOf(filterToAdd) >= 0 ? filtersAppliedDelimited : filtersAppliedDelimited + FILTERS_APPLIED_DELIMITER + filterToAdd;
    } else {
        result = filterToAdd;
    }

    return result;
}

function removeFilterApplied(filtersAppliedDelimited, filterToRemove) {
    // /-{1}filter|filter{1}-|filter/g
    return filtersAppliedDelimited.replaceAll(new RegExp('-{1}' + filterToRemove + '|' + filterToRemove + '-{1}|' + filterToRemove, 'g'), '');
}

function clearFilters() {
    FILTER_NAMES.map(function (filter) {
        getFilterInputs(filter).prop('checked', false);
    });

    clearPredictiveDesignerSearch();
    removeHash(removeURLParameter(window.location.href, 'filters'));
    applyFilters();
}

// Using a wrapper function for now, in case I want to separate functions later.
function setPageNumber(page) {
    applyFilters({ pageNum: page });
}

function clearFilterFromURL(url, filter) {
    return removeURLParameter(url, filter);
}

function getFilterValues(filter) {
    var values = [];
    var checked = getFilterInputs(filter).filter(':checked');
    var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>');
    checked.each(function (i, element) {
        values.push($div.html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).attr('value')).text()); // Basically decode & trim...?
    });
    var numChecked = checked.length;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.filters__count-' + filter).html(numChecked > 0 ? "(" + numChecked + ")" : "");
    return values;
}

function getFilterInputs(filter) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[type="checkbox"][name="' + filter + '"]');
}

function clearQueryParameters(url, params) {
    for (var p in params) {
        url = removeURLParameter(url, p);
    }

    return url;
}

function getQuery(url) {
    return url.indexOf("?") > -1 ? url.substring(url.indexOf("?") + 1) : "";
}

function appendQuery(url, query) {
    if ("" == query) {
        return url;
    }
    query = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div/>').html(query).text();
    return url + (url.indexOf("?") > -1 ? "&" : "?") + query;
}

// http://stackoverflow.com/a/1634841
function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

        var encodedPrefix = encodeURIComponent(parameter) + '=';
        var unencodedPrefix = parameter + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(encodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            } else if (pars[i].lastIndexOf(unencodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}

// Safe concatenation of url and param strings with taking care of '?' and '&' characters
function safeConcat(url, paramString) {

    var result = '';

    // get rid of the leading '?' or '&' characters
    paramString = removeLeadingChars(paramString);

    var endsWithAmpOrQuestion = /[\?&]$/;

    if (url.indexOf('?') > -1) {
        if (url.match(endsWithAmpOrQuestion)) {
            result = url + paramString;
        } else {
            result = url + '&' + paramString;
        }
    } else {
        result = url + '?' + paramString;
    }

    return result;
}

// Remove the leading '?' or '&' characters
function removeLeadingChars(paramString) {
    // remove RegExp
    var re = /^[?&]+/;
    return paramString.replace(re, '');
}

// Replace existing parameters in url with new values in parameterString
function replaceURLParameters(url, parameterString) {
    if (!parameterString) return url;

    var parameters = parameterString.split('&');
    var rtn = url;
    var tmp = '';
    if (parameters) {
        for (var i = 0; i < parameters.length; i++) {
            var p = parameters[i];
            if (p) {
                var parameterPair = p.split('=');
                if (parameterPair && parameterPair.length == 2) {
                    rtn = removeURLParameter(rtn, parameterPair[0]);
                }
                tmp = appendQuery(tmp, p);
            }
        }

        rtn = safeConcat(rtn, tmp);
    }
    return rtn;
}

function initPreNext() {
    if (window.localStorage) {
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product-code-div").data("productList");
        var maxListSize = 20;
        if (data) {
            var listIndex = window.localStorage.getItem("current-index");
            if (!listIndex) listIndex = 0;
            var index = (parseInt(listIndex) + 1) % maxListSize;
            var newKey = "plp-list-" + index;

            window.localStorage.setItem("current-index", index);
            window.localStorage.setItem(newKey, data);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".product__link").click(function (event) {
                var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href");
                if (url.indexOf("?") == -1) {
                    url += "?list=" + newKey;
                } else {
                    url += "&list=" + newKey;
                }
                url = url.replace(/\?&+/g, "?").replace(/&+/g, "&"); // remove extra & in the url
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("href", url);
            });
        }
    }
}

function dynamicallyDisableFilters() {
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        url: window.location.href
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: '/fw/content/products/applicable-filters/',
        data: data,
        dataType: 'json',
        type: 'GET',
        success: function success(rtn) {
            if (rtn && rtn.filters) {
                for (var filterType in rtn.filters) {
                    if (rtn.filters.hasOwnProperty(filterType)) {
                        var obj = rtn.filters[filterType];
                        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isPlainObject(obj)) {
                            // extra level since they're grouped (i.e., sizes)
                            for (var filterKey in obj) {
                                if (obj.hasOwnProperty(filterKey)) {
                                    var filterList = obj[filterKey];
                                    for (var k = 0; k < filterList.length; k++) {
                                        enableOrDisableFilter(filterList[k]);
                                    }
                                }
                            }
                        } else {
                            for (var j = 0; j < obj.length; j++) {
                                enableOrDisableFilter(obj[j]);
                            }
                        }
                    }
                }
            }
        }
    });
}

function applyEnabledOrDisabledStyle(filter, disabled, category) {
    if (filter) {
        filter.prop('disabled', disabled);
        var siblings = filter.siblings('label');
        var label = siblings && siblings.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(siblings[0])
        // check if the input is a child of a label (initially for an AB test of designer search)
        : filter.parent('label');
        if (label) {
            var cssClass = category === "sustainability" ? "sustainable__filter--disabled" : "filters__size--disabled";
            if (disabled) {
                label.addClass(cssClass);
                label.attr('aria-disabled', 'true');
            } else {
                label.removeClass(cssClass);
                label.attr('aria-disabled', 'false');
            }
        }

        //if somehow the filter was chosen, deselect it, this will trigger another AJAX fetch of the product set
        //ideally these should have already been removed before we get here
        if (disabled && filter.prop("checked")) {
            filter.prop("checked", false);
            filter.trigger("change");
        }
    }
}

window.enableOrDisableFilter = function (filterObj) {
    if (filterObj) {
        var filter = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + filterObj.idForHTML);
        if (filter) {
            applyEnabledOrDisabledStyle(filter, filterObj.disabled, filterObj.category);
        }
    }
};

/***/ })

},[158]);


// WEBPACK FOOTER //
// dist/plp.js